import React, { useContext } from "react";
import Image from "next/image";
import { Checkbox } from "@mui/material";
import { CommonDataContext } from "context/CommonDataContext";
import { extractResource } from "helper/extractResource";
import moment from "moment";
import { useCityName } from "@/utils/customHooks/useCityName";
import { Journey } from "@/types/*";
import { CHECKIN_OPENS_48_HOURS_PRIOR } from "../../../../constants/variables";
import getNoOfStops from "../../../../helper/flightStops";
import { RightArrow } from "../../../../public/svg/RightArrow";
import AccessTime from "../../../../public/svg/time.svg";

interface CheckinJourneySelectionCardProps {
  journeyCard: Journey & { isChecked: boolean } & { restrictions: [] };
  toggle: (e: any, journeyKey: string) => void;
  id: number;
}

export function CheckinJourneySelectionCardGroupV2({ journeyCard, toggle, id }: CheckinJourneySelectionCardProps) {
  const lab = { inputProps: { "aria-label": "Checkbox demo" } };

  const cityName = useCityName();
  const { resources } = useContext(CommonDataContext);
  const newRestriction = journeyCard?.restrictions === null ? "opened" : journeyCard?.restrictions?.toString();

  return (
    <div className="w-full ">
      <div
        id="flightDetails"
        className="w-full flex justify-between items-center pt-2 pb-2"
        key={journeyCard.journeyKey}
      >
        <div className="flex bg-background-primary w-full">
          <div id="flightDate" className={`h-auto px-5 w-12 bg-gray-200 rounded`}>
            <div className="flex flex-col items-center justify-center h-full">
              <p
                id="journeyDay"
                className="m-0 mb-1 font-semibold text-2xl leading-6 text-center uppercase text-gray-800"
              >
                {moment(journeyCard.designator.departure).format(" D")}
              </p>
              <p
                id="journeyMonth"
                className="m-0 mb-1 font-semibold text-xs leading-3 text-center uppercase text-gray-800"
              >
                {moment(journeyCard.designator.departure).format(" MMM")}
              </p>
            </div>
          </div>
          <div id="flightJourney" className="w-full">
            <div className="flex flex-row mt-1 items-center">
              <p
                id="journeyOrigin"
                className="font-semibold text-sm m-0 leading-3 flex items-center ml-2 text-typography-primary"
              >
                {cityName(journeyCard.designator.origin)}
              </p>
              <div className="ml-2">
                <RightArrow />
              </div>
              <p
                id="journeyDestination"
                className="font-semibold text-sm m-0 leading-3 flex items-center ml-2 text-typography-primary"
              >
                {cityName(journeyCard.designator.destination)}
              </p>
            </div>
            <p
              id="journeyDetails"
              className="m-0 font-normal text-xs flex items-center pt-2 ml-2 text-typography-secondary"
            >
              {getNoOfStops(journeyCard.stops)}
              &nbsp;•&nbsp;
              {journeyCard.flightNos.join(", ")}
            </p>

            {newRestriction?.toLowerCase().includes("notopened") ? (
              <div>
                <div className="flex flex-row gap-1 items-center font-medium text-xs pl-2 pt-2 pb-1 text-gray-700">
                  <Image src={AccessTime} alt="Access Time" width={12} height={12} />
                  {CHECKIN_OPENS_48_HOURS_PRIOR}
                </div>
              </div>
            ) : (
              <div>
                <div className="flex flex-row items-center font-medium text-xs pl-2 pt-2 pb-1 text-gray-700">
                  {newRestriction?.toLowerCase().includes("closed") && extractResource(resources, "flown")}
                </div>
              </div>
            )}
          </div>
        </div>
        {journeyCard && newRestriction?.includes("opened") && !newRestriction?.includes("notopened") && !newRestriction?.includes("closed") && (
          <div className="bg-background-primary px-2 sm:px-0 dark:py-[25.5px] sm:dark:py-[17px] min-h-full rounded-r">
            <Checkbox
              id="checkbox"
              checked={journeyCard?.isChecked || false}
              name={`journeyCard${id}`} // Ensure `id` is defined in the scope
              onChange={(e) => toggle(e, journeyCard.journeyKey)} // Ensure `toggle` is a function with the correct signature
              color="primary"
              {...lab} // Ensure `lab` is defined and contains valid props for Checkbox
            />
          </div>
        )}
      </div>
    </div>
  );
}